import type { BasePalette, CliPalette, Colors } from './types'

const baseColors: Record<'light' | 'dark', BasePalette> = {
  light: {
    base: '#FFFFFF',

    bg1: '#FFFFFF',
    bg2: '#FBFBFB',
    bg3: '#EAEAEA',
    bgError: '#FFFBFB',
    bgWarning: '#FFFDF9',
    bgSuccess: '#F7FCF7',

    text1: '#1B1B1B',
    text2: '#606060',
    text3: '#7C7C7C',
    text4: '#BCBCBC',
    textAccent: '#FFFFFF',
    textSecondary: '#FFFFFF',
    textError: '#A32929',
    textWarning: '#855E15',

    accent: '#4A9C6D',
    accentHover: '#41895F',
    secondary: '#1672C3',
    secondaryHover: '#258AE2',
    error: '#BE4444',
    errorHover: '#A83A3A',
    success: '#50B490',
    successHover: '#449f7e',
    warning: '#C18F2D',
    warningHover: '#9F792E',

    transparent: '#FFFFFF00',

    gradient: 'linear-gradient(89.97deg, #19A05F 0.02%, #0D7F8C 123.85%)',

    reversed: '#000000',
    textReversed: '#FFFFFF'
  },
  dark: {
    base: '#000000',

    bg1: '#131316',
    bg2: '#222226',
    bg3: '#363739',
    bgError: '#1F1919',
    bgWarning: '#1D1B18',
    bgSuccess: '#1A1C1A',

    text1: '#FFFFFF',
    text2: '#BFBFBF',
    text3: '#A4A4A4',
    text4: '#55565C',
    textAccent: '#FFFFFF',
    textSecondary: '#FFFFFF',
    textError: '#FB8181',
    textWarning: '#FFCF73',

    accent: '#4A9C6D',
    accentHover: '#41895F',
    secondary: '#1672C3',
    secondaryHover: '#258AE2',
    error: '#BE4444',
    errorHover: '#A83A3A',
    success: '#50B490',
    successHover: '#449F7E',
    warning: '#D69E34',
    warningHover: '#BC8720',

    transparent: '#FFFFFF00',

    gradient: 'linear-gradient(89.97deg, #19A05F 0.02%, #0D7F8C 123.85%)',

    reversed: '#FFFFFF',
    textReversed: '#000000'
  }
}

const cliColors: Record<'light' | 'dark', CliPalette> = {
  light: {
    'cli-green': '#00BA8D',
    'cli-lime': '#9ED034',
    'cli-purple': '#D978DF',
    'cli-blue': '#74AEE1',
    'cli-cyan': '#00C2D7',
    'cli-grey': '#9B9B9B',
    'cli-darkGrey': '#B5B5B5'
  },
  dark: {
    'cli-green': '#25D2A9',
    'cli-lime': '#9ED034',
    'cli-purple': '#D978DF',
    'cli-blue': '#74AEE1',
    'cli-cyan': '#00C2D7',
    'cli-grey': '#B0B0B0',
    'cli-darkGrey': '#5B686D'
  }
}

export const colors: Colors = {
  light: {
    ...baseColors.light,
    ...cliColors.light
  },
  dark: {
    ...baseColors.dark,
    ...cliColors.dark
  }
}
